module.exports = __webpack_public_path__ + "img/otherDocument.d7d6a747.svg";